import { render, staticRenderFns } from "./RequirementsSettings.vue?vue&type=template&id=45f8c00c&"
import script from "./RequirementsSettings.vue?vue&type=script&lang=js&"
export * from "./RequirementsSettings.vue?vue&type=script&lang=js&"
import style0 from "./RequirementsSettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports